import { createSlice } from "@reduxjs/toolkit";

const priceFormatt = createSlice({
    initialState:{
        format:'Absolute',
    },
    name: "priceFormat",
    reducers: {
        setPriceFormat: (state, action) => {
            state.format = action.payload;
        },
        resetPriceFormat: (state) => {
            state.format = 'absolute';
        }
    }
})

export const { setPriceFormat, resetPriceFormat } = priceFormatt.actions;
export default priceFormatt.reducer;